import MonitoringServiceConfirmMonitoringModal from './monitoring-service-confirm-monitoring-modal.vue'
export default MonitoringServiceConfirmMonitoringModal
